
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexcCWt1D0L5KiND3REOjdOX7MYroFVVA9677Ri_jjjqtIMeta } from "/tmp/tmp48nj1ri7/pages/[area]/[pref]/[id]/index.vue?macro=true";
import { default as indexV2MKQOttU4ORNHhwe65_iFBMcW3TOrYDm_08GshJ0SwMeta } from "/tmp/tmp48nj1ri7/pages/[area]/[pref]/index.vue?macro=true";
import { default as indexIt5ZmKLvMAi7Vc2mGatUKUjh8RYZO1HoPdcR_45asHAFkMeta } from "/tmp/tmp48nj1ri7/pages/[area]/index.vue?macro=true";
import { default as indexFTPuq5FkOgHSBp3MnHOAt41nLlI_45vqqOdMn8YUTp5W8Meta } from "/tmp/tmp48nj1ri7/pages/index.vue?macro=true";
import { default as indexcp3L7gHoNvNqmI_qnx__9ygC2wuM7ZbE1EZbF8XOFo0Meta } from "/tmp/tmp48nj1ri7/pages/okinawa/[id]/index.vue?macro=true";
import { default as index1zBoQdhJMpynhQqHepU0wI4Si_EWL6mnGpMIUFCYIokMeta } from "/tmp/tmp48nj1ri7/pages/okinawa/index.vue?macro=true";
import { default as index_45rsSywP0fk_TRSQN1LqufnpPgaWw8IdBZ0lJS8G4HxMMeta } from "/tmp/tmp48nj1ri7/pages/zoom-map/index.vue?macro=true";
export default [
  {
    name: "area-pref-id",
    path: "/:area()/:pref()/:id()",
    component: () => import("/tmp/tmp48nj1ri7/pages/[area]/[pref]/[id]/index.vue")
  },
  {
    name: "area-pref",
    path: "/:area()/:pref()",
    component: () => import("/tmp/tmp48nj1ri7/pages/[area]/[pref]/index.vue")
  },
  {
    name: "area",
    path: "/:area()",
    component: () => import("/tmp/tmp48nj1ri7/pages/[area]/index.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/tmp/tmp48nj1ri7/pages/index.vue")
  },
  {
    name: "okinawa-id",
    path: "/okinawa/:id()",
    component: () => import("/tmp/tmp48nj1ri7/pages/okinawa/[id]/index.vue")
  },
  {
    name: "okinawa",
    path: "/okinawa",
    component: () => import("/tmp/tmp48nj1ri7/pages/okinawa/index.vue")
  },
  {
    name: "zoom-map",
    path: "/zoom-map",
    component: () => import("/tmp/tmp48nj1ri7/pages/zoom-map/index.vue")
  }
]